(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsMeasureSelector', function () {
    return {
      templateUrl: "modules/common/directives/measure-selector/measure-selector.html"
    };
  });
})();
